export const REVIEW_MAP_FIXTURE = Object.freeze({
  mindmapId: 'local-review-map',
  nodes: [
    {
      id: 'review-root',
      text: 'Project launch',
      position: { x: 520, y: 320 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'right', order: 0, pinned: true },
      color: 'linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)',
      isRoot: true,
    },
    {
      id: 'review-research',
      text: 'Research customers',
      position: { x: 120, y: 220 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'left', order: 0, pinned: false },
      color: 'linear-gradient(135deg, #0891b2 0%, #0f766e 100%)',
    },
    {
      id: 'review-release',
      text: 'Prepare release',
      position: { x: 920, y: 420 },
      layoutSize: { width: 260, height: 110 },
      layout: { side: 'right', order: 0, pinned: false },
      color: 'linear-gradient(135deg, #ea580c 0%, #dc2626 100%)',
    },
  ],
  relationships: [
    { parentId: 'review-root', childId: 'review-research' },
    { parentId: 'review-root', childId: 'review-release' },
  ],
  root: 'review-root',
  selectedId: 'review-root',
});
